import React, { memo, useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { useInView } from 'react-intersection-observer';

import styles from './_LogInView.module.less';
import { logging, logPostInfo } from '../../actions/log';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

export default ({ cardData, logInfo, children, time = 1000 }) => {
  const dispatch = useDispatch();
  const logInfoData = useSelector(selectLogInfo);

  const [cardLogInfo, setCardLogInfo] = useState({ inTime: 0, timeIndex: 0 });
  const [isNeedLog, setIsNeedLog] = useState(false);
  const [refInView, inView, entry] = useInView({
    threshold: 0.75,
  });

  // 销毁元素则清除timeout事件
  useEffect(() => {
    return () => {
      if (cardLogInfo?.timeIndex) {
        clearTimeout(cardLogInfo?.timeIndex);
      }
    };
  }, [cardLogInfo]);

  // 依赖于inView 判断是否需求等待一秒钟后上报展现 设置isNeedLog为true
  useEffect(() => {
    if (inView) {
      setCardLogInfo(info => {
        if (info?.timeIndex) {
          clearTimeout(info?.timeIndex);
        }
        let info_ = {
          inTime: +new Date(),
          timeIndex: 0,
        };

        info_.timeIndex = setTimeout(() => {
          // loggingCardInView(time);
          setIsNeedLog(true);
        }, time);
        return info_;
      });
    }
    if (!inView) {
      setCardLogInfo(info => {
        if (info?.timeIndex) {
          clearTimeout(info?.timeIndex);
        }
        return {
          inTime: 0,
          timeIndex: 0,
        };
      });
    }
  }, [inView]);

  useEffect(() => {
    if (isNeedLog) {
      handleLogging({ time, inViewTime: cardLogInfo.inTime });
      setIsNeedLog(false);
    }
  }, [isNeedLog, cardData, logInfo, cardLogInfo]);

  // useEffect(() => {
  //   if (inView) {
  //     if (!cardLogInfo?.inTime || !cardLogInfo?.timeIndex) {
  //       // cardLogInfo 如果timeIndex值存在，就直接清空
  //       if (cardLogInfo?.timeIndex) {
  //         clearTimeout(cardLogInfo?.timeIndex);
  //       }
  //       let cardLogInfo_ = {
  //         inTime: +new Date(),
  //         timeIndex: 0,
  //       };
  //       cardLogInfo_.timeIndex = setTimeout(() => {
  //         loggingCardInView(time);
  //       }, time);
  //       setCardLogInfo(cardLogInfo_);
  //     }
  //   }
  //   if (!inView) {
  //     if (cardLogInfo?.timeIndex || cardLogInfo.inTime) {
  //       // cardLogInfo 如果timeIndex值存在，就直接清空
  //       if (cardLogInfo?.timeIndex) {
  //         clearTimeout(cardLogInfo?.timeIndex);
  //       }
  //       setCardLogInfo({
  //         inTime: 0,
  //         timeIndex: 0,
  //       });
  //     }
  //   }
  // }, [inView, cardData, logInfo, cardLogInfo]);

  // const loggingCardInView = useCallback(
  //   time => {
  //     handleLogging({ time, inViewTime: cardLogInfo.inTime });
  //   },
  //   [logInfoData, cardData, logInfo, cardLogInfo],
  // );

  const handleLogging = useCallback(
    (param2 = {}) => {
      dispatch(
        logging({
          category: logInfo?.categoryAction ?? 'I',
          action: logInfo?.logAction || `${logInfo?.clTag || logInfo?.tag}_Content_Detail`,
          label: '',
          param2: {
            ...logInfo,
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            ...param2,
            logAction: undefined,
          },
          param3: cardData?.bizInfo || '{}',
        }),
      );
    },
    [cardData, logInfo],
  );

  return (
    <div className={styles.log_inview} ref={refInView}>
      {children}
    </div>
  );
};
